import React from 'react';
import { IconBase } from '../Base';
export const IconCheckmark = (props) => {
    return (React.createElement(IconBase, { ...props },
        React.createElement("path", { fill: "none", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round", d: "M14.75 6.5L8.25 13.5L5.25 10.3636", style: { stroke: 'var(--icon-color)' } })));
};
//# sourceMappingURL=Checkmark.js.map